import { useMutation, useQueryClient } from "react-query";
import axiosClient from "./axios";
import { enqueueSnackbar } from "notistack";

const useMutateRascunho = (componente: TRascunhoComponentes): IMutateRascunho => {

    const queryClient = useQueryClient();

    //queries e mutations
    const { mutate: salvarRascunho, isLoading: isLoadingSalvarRascunho } = useMutation({
        mutationKey: 'salvar-rascunho',
        mutationFn: (inputs: any) => axiosClient.post("/salvar-rascunho", { componente, ...inputs }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }),
        onError: (error) => {
            console.error(error)
            queryClient.invalidateQueries("lista-pesquisar-rascunhos")
            enqueueSnackbar('Erro ao salvar o rascunho!', { variant: 'error' });
        },
        onSuccess: () => {
            queryClient.invalidateQueries("lista-pesquisar-rascunhos")
            enqueueSnackbar(`Rascunho salvo com sucesso!`, { variant: 'success' });
        }
    })

    const { mutate: removerRascunho, isLoading: isLoadingRemoverRascunho } = useMutation({
        mutationKey: 'excluir-rascunho',
        mutationFn: (id: number) => axiosClient.delete("/excluir-rascunho/" + id),
        onError: (error) => {
            console.error(error)
            enqueueSnackbar('Erro ao excluir rascunho!', { variant: 'error' });
        },
        onSuccess: () => {
            queryClient.invalidateQueries("lista-pesquisar-rascunhos")
            enqueueSnackbar(`Rascunho excluído com sucesso!`, { variant: 'success' });
        }
    })
    //

    //funções manipuladoras
    const handleSaveRascunho = (dados: Record<string, any>, arquivos: string[]) => {
        const jsonData = JSON.stringify(dados)
        salvarRascunho({ dados: jsonData, arquivos })
    }

    const handleDeleteRascunho = async (id: number) => {
        await removerRascunho(id)
    }
    //

    return {
        handleSaveRascunho,
        isLoadingSalvarRascunho,
        handleDeleteRascunho,
        isLoadingRemoverRascunho
    };
}

export default useMutateRascunho;

interface IMutateRascunho {
    handleSaveRascunho: (dados: Record<string, any>, arquivos: string[]) => void,
    isLoadingSalvarRascunho: boolean,
    handleDeleteRascunho: (id: number) => void,
    isLoadingRemoverRascunho: boolean
}

export type TRascunhoComponentes = "SolicitarAnaliseCredito" | "GerarOrdemCompra"